exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-label[data-v-9aedd738]{min-width:100px;display:flex;align-items:center}.image-label .trash[data-v-9aedd738]{width:16px;height:16px;margin-left:8px}.article-quantity-list[data-v-9aedd738]{margin-top:10px;display:grid;grid-template-columns:auto 100px;align-items:center}.article-quantity-list .column[data-v-9aedd738]{margin:5px 0}.article-quantity-list .two-column[data-v-9aedd738]{grid-column:span 2}", ""]);

// exports
